module.exports = "\n<{{tag}} src={{url}} {{attrs}}/>\n<div class=\"js-gallery-loading-region gallery-loading-region\"></div>";